import { render, staticRenderFns } from "./PdSettingsView.vue?vue&type=template&id=eccdedde&"
import script from "./PdSettingsView.vue?vue&type=script&lang=js&"
export * from "./PdSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports